import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=0f9fffa8&scoped=true"
import script from "./step2.vue?vue&type=script&lang=ts"
export * from "./step2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fffa8",
  null
  
)

export default component.exports